import { STORYBLOK_VIDEO_BASE_URL } from "../constants";

export function getStoryblokVideoUrl(url: string) {
  return url.replace("//a.storyblok.com", STORYBLOK_VIDEO_BASE_URL);
}
